<template>
  <widget
    :title="$tc('words.detail', 2)"
    :button="true"
    :button-text="
      agentId ? $tc('phrases.openAgent') : $tc('phrases.deleteCustomer', 1)
    "
    @widgetAction="agentId ? openAgent() : confirmDelete()"
    :button-icon="agentId ? 'support_agent' : 'delete'"
    :show-spinner="false"
  >
    <md-card>
      <md-card-content>
        <div class="md-layout md-gutter md-alignment-center" v-if="!editPerson">
          <div class="md-layout-item">
            <div class="md-layout md-alignment-center-left">
              <div class="md-layout-item md-size-20">
                <md-avatar class="md-avatar-icon md-large">
                  {{ initials }}
                </md-avatar>
              </div>
              <div class="md-layout-item">
                <h2>
                  {{ this.personService.person.title }}
                  {{ this.personService.person.name }}
                  {{ this.personService.person.surname }}
                  <md-chip
                    v-if="this.personService.person.type === 'agent'"
                    class="md-primary"
                  >
                    {{ $tc("words.agent") }}
                  </md-chip>
                </h2>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-20">
            <md-button
              @click="editPerson = true"
              class="md-icon-button md-raised"
              style="float: right"
            >
              <md-icon>create</md-icon>
            </md-button>
          </div>

          <div class="md-layout-item md-size-100">
            <md-list class="md-double-line">
              <md-list-item>
                <md-icon>wc</md-icon>
                <div class="md-list-item-text">
                  <span>{{ $tc("words.gender") }}</span>
                  <span>{{ this.personService.person.gender || "N/A" }}</span>
                </div>
              </md-list-item>
              <md-divider></md-divider>
              <md-list-item>
                <md-icon>school</md-icon>
                <div class="md-list-item-text">
                  <span>{{ $tc("words.education") }}</span>
                  <span>
                    {{ this.personService.person.education || "N/A" }}
                  </span>
                </div>
              </md-list-item>
              <md-divider></md-divider>
              <md-list-item>
                <md-icon>cake</md-icon>
                <div class="md-list-item-text">
                  <span>{{ $tc("words.birthday") }}</span>
                  <span>
                    {{ this.personService.person.birthDate || "N/A" }}
                  </span>
                </div>
              </md-list-item>
            </md-list>
          </div>
        </div>

        <div class="md-layout md-gutter" v-else>
          <div class="md-layout-item md-size-100">
            <form class="md-layout" @submit.prevent="updatePerson">
              <md-field>
                <label for="title">
                  {{ $tc("words.title") }}
                </label>
                <md-input
                  type="text"
                  name="person-title"
                  id="person-title"
                  v-model="personService.person.title"
                />
              </md-field>
              <md-field
                :class="{
                  'md-invalid': errors.has($tc('words.title')),
                }"
              >
                <label for="name">
                  {{ $tc("words.name") }}
                </label>
                <md-input
                  type="text"
                  name="name"
                  id="name"
                  v-validate="'required'"
                  v-model="personService.person.name"
                />
                <span class="md-error">
                  {{ errors.first($tc($tc("words.name"))) }}
                </span>
              </md-field>
              <md-field
                :class="{
                  'md-invalid': errors.has($tc('words.surname')),
                }"
              >
                <label for="surname">
                  {{ $tc("words.surname") }}
                </label>
                <md-input
                  type="text"
                  name="surname"
                  id="surname"
                  v-model="personService.person.surname"
                  v-validate="'required'"
                />
                <span class="md-error">
                  {{ errors.first($tc($tc("words.surname"))) }}
                </span>
              </md-field>
              <md-datepicker
                name="birthDate"
                md-immediately
                v-model="personService.person.birthDate"
                :md-close-on-blur="false"
              >
                <label for="birth-date">{{ $tc("words.birthday") }} :</label>
              </md-datepicker>
              <md-field>
                <label for="gender">{{ $tc("words.gender") }} :</label>
                <md-select
                  name="gender"
                  id="gender"
                  v-model="personService.person.gender"
                >
                  <md-option
                    disabled
                    v-if="personService.person.gender == null"
                  >
                    -- {{ $tc("words.select") }} --
                  </md-option>
                  <md-option value="male">
                    {{ $tc("words.male") }}
                  </md-option>
                  <md-option value="female">
                    {{ $tc("words.female") }}
                  </md-option>
                  <md-option value="non-binary">
                    {{ $tc("words.nonBinary") }}
                  </md-option>
                </md-select>
              </md-field>
              <md-field>
                <label for="education">
                  {{ $tc("words.education") }}
                </label>
                <md-input
                  type="text"
                  name="education"
                  id="education"
                  v-model="personService.person.education"
                />
              </md-field>
              <div class="md-layout-item md-size-100">
                <md-button
                  type="submit"
                  class="md-raised md-primary"
                  style="float: right !important"
                >
                  {{ $tc("words.save") }}
                </md-button>
                <md-button
                  type="button"
                  @click="editPerson = false"
                  class="md-raised"
                  style="float: right !important"
                >
                  {{ $tc("words.cancel") }}
                </md-button>
              </div>
            </form>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </widget>
</template>

<script>
import { PersonService } from "@/services/PersonService.js"
import Widget from "@/shared/Widget.vue"

export default {
  name: "ClientPersonalData",
  components: {
    Widget,
  },
  props: {
    person: {
      required: true,
    },
  },
  data() {
    return {
      personService: new PersonService(),
      editPerson: false,
    }
  },
  mounted() {
    this.personService.person = this.person
  },
  computed: {
    initials() {
      const person = this.personService.person
      if (!person) return ""

      const first = person.name?.charAt(0) ?? ""
      const last = person.surname?.charAt(0) ?? ""

      return (first + last).toUpperCase()
    },
    agentId() {
      return this.personService.person?.agentId ?? null
    },
  },
  methods: {
    async updatePerson() {
      const validator = await this.$validator.validateAll()
      if (!validator) return
      const personParams = {
        id: this.personService.person.id,
        name: this.personService.person.name,
        surname: this.personService.person.surname,
        title: this.personService.person.title,
        education: this.personService.person.education,
        birthDate: this.personService.person.birthDate,
        gender: this.personService.person.gender,
      }
      await this.personService.updatePerson(personParams)
      this.editPerson = false
    },
    openAgent() {
      this.$router.push(`/agents/${this.agentId}`)
    },
    confirmDelete() {
      this.$swal({
        type: "question",
        title: this.$tc("phrases.deleteCustomer", 1),
        text: this.$tc("phrases.deleteCustomerNotify", 0, {
          name: this.personService.person.name,
          surname: this.personService.person.surname,
        }),
        width: "35%",
        confirmButtonText: this.$tc("words.confirm"),
        showCancelButton: true,
        cancelButtonText: this.$tc("words.cancel"),
        focusCancel: true,
      }).then((result) => {
        if (result.value) {
          this.deletePerson()
        }
      })
    },
    async deletePerson() {
      try {
        await this.personService.deletePerson(this.personService.person.id)
        this.showConfirmation()
      } catch (error) {
        this.$swal({
          type: "error",
          title: this.$tc("phrases.somethingWentWrong"),
          text: error.message || "Failed to delete customer",
        })
      }
    },
    showConfirmation() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer)
          toast.addEventListener("mouseleave", this.$swal.resumeTimer)
        },
      })

      Toast.fire({
        type: "success",
        title: this.$tc("phrases.deleteCustomer", 1),
      }).then((x) => {
        console.log(x)
        window.history.back()
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
